<template>
  <el-form-item :label="i18nt('designer.setting.plain')">
    <el-switch v-model="optionModel.plain"></el-switch>
  </el-form-item>
</template>

<script>
import { toRefs } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'plain-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
    };
  },
};
</script>

<style scoped></style>
